export default "https://cdn-static-staging.gokick.com/assets/98f5e78fc13494034d6569c4b787741d65d3002e/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";